'use client';

import { usePathname } from 'next/navigation';

import { Link } from '@/i18n/routing';
import { cn } from '@/lib/utils';
import type { DocNavSection } from '@/types/content';

interface DocsSidebarProps {
  items: DocNavSection[];
}

export function DocsSidebar({ items }: DocsSidebarProps) {
  const pathname = usePathname();

  return (
    <div className="w-full space-y-6">
      {items.map((item, index) => (
        <div key={index}>
          <h4 className="mb-3 text-sm font-semibold text-foreground">{item.section}</h4>
          {item.pages?.length > 0 && (
            <div className="space-y-1">
              {item.pages.map((page) => {
                const href = `/docs/${page.slug.join('/')}`;
                const isActive = pathname === href;

                return (
                  <Link
                    key={href}
                    href={href}
                    className={cn(
                      'block px-3 py-2 text-sm rounded-lg transition-all',
                      isActive
                        ? 'bg-primary/10 text-primary font-medium'
                        : 'text-muted-foreground hover:bg-muted hover:text-foreground',
                    )}
                  >
                    {page.title}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
